import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-white py-16 sm:py-24" data-id="element-62" data-mp="1gjvhz41cx3g8">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-63" data-mp="248xzmbvzqwaq">
        <SectionHeading title="Preguntas frecuentes" data-id="element-64" data-mp="24bk60875b5rd" />
        <Reveal className="mt-10" data-id="element-65" data-mp="289qblcw8zfap">
          <ul className="divide-y divide-slate-200 border-y border-slate-200" data-id="element-66" data-mp="28cvwefxufv0m">
            {faqs.map((faq, i) => {
            const isOpen = open === i;
            const panelId = `faq-panel-${i}`;
            return <li key={faq.question} data-id="element-67" data-mp="2n8btyuxmu91r" data-mpi={i}>
                  <h3 data-id="element-68" data-mp="2n6hall20eozs">
                    <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-bold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:text-lg" data-id="element-69" data-mp="2n5z7c4gxjaid">
                      {faq.question}
                      <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-70" data-mp="19t2d3if6hvj8" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-71" data-mp="1xj6dzi0zfh6j">
                    {isOpen && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-72" data-mp="1slebxv6mieom">
                        <p className="pb-5 text-base leading-relaxed text-slate-600" data-id="element-73" data-mp="238g24usy1t9r">{faq.answer}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}